import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_USER_CHAT_GROUPS } from "@app/apollo/queries/chat-group.query";
import { chatSocketService } from "@app/services/chat-socket.service";

const useGlobalGroupChatSubscription = (user) => {
  const [fetchUserGroups] = useLazyQuery(GET_USER_CHAT_GROUPS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.userChatGroups?.length) {
        const eventIds = data.userChatGroups
          .map((group) => group.id)
          .filter(Boolean);

        if (eventIds.length > 0) {
          if (process.env.NODE_ENV === 'development') {
            console.log('[GroupChat] Bulk subscribing to', eventIds.length, 'event rooms');
          }
          chatSocketService.subscribeEvents(eventIds);
        }
      } else if (process.env.NODE_ENV === 'development') {
        console.log('[GroupChat] No chat groups found for user');
      }
    },
    onError: (error) => {
      console.error('[GroupChat] Failed to fetch user chat groups:', error);
    },
  });

  useEffect(() => {
    if (user?.id) {
      fetchUserGroups();
    }
  }, [user?.id]);
};

export default useGlobalGroupChatSubscription;
